// architectureConfig — the BlockConfig registry consumed by BlockRenderer.
//
// Each entry maps a block-type string (as it appears in page_content recipes)
// to a React component from the platform block library. Components receive
// their props verbatim from the recipe.
//
// The cast is at the boundary: the runtime contract is "props from JSON",
// inherently Record<string, unknown>. Concrete components are typed in
// PlatformBlocks.tsx for IDE/intellisense but registered through the cast.

import type { BlockConfig } from "./BlockRenderer";
import {
  BodyText,
  BulletList,
  Callout,
  Chip,
  DocLink,
  Hero,
  ImageBlock,
  KeyValue,
  Kpi,
  Section,
  Table,
  Timeline,
} from "./PlatformBlocks";

export const architectureConfig: BlockConfig = {
  components: {
    Hero,
    Section,
    BodyText,
    Callout,
    Table,
    BulletList,
    ImageBlock,
    KeyValue,
    DocLink,
    Chip,
    Kpi,
    Timeline,
  } as unknown as BlockConfig["components"],
};
